import { Injectable } from '@angular/core';


/**
 * Permite interactuar con el localStorage
 */
@Injectable({
  providedIn: 'root'
})
export class PersistenceService {

  constructor() { }

  /**
   *  Permite almacenar un valor en el localStorage
   * @param key identificafdor en el localStorage
   * @param value string a almacenar en el local storage
   */
  addValue(key: Keys, value: string): void {
    localStorage.setItem(key, value);
  }

  /**
   * Permite leer un valor desde el localStorage
   * @param key identificador del valor que se quiere obtener
   */
  getValue(key: Keys): string {
    return localStorage.getItem(key);
  }

  /**
   *
   * @param key identificador del valor que se desea eliminar del localStorage
   */
  removeValue(key: Keys): void {
    localStorage.removeItem(key);
  }

  /**
   * remove all items in localstorage
   */
  clear() {
    localStorage.clear();
  }

}

/**
 * Los valores permitidos para leer o escribir en el localStorage
 */
export enum Keys {
  accessToken = 'accessToken',
  isAuthenticate = 'isAuthenticate',
  role = 'role',
  user = 'user'
}
